import * as React from 'react';
import Select from 'react-select';
import { IObservableObject, observable } from 'mobx';
import { EmployeeDto } from '../../pages/user/userTypes';
import { observer } from 'mobx-react';
import { getEmployees } from '../../pages/user/userApi';
import { Typography } from '@material-ui/core';
import { translation } from '../../i18n';
import { SelectedAppraisee } from '../../pages/questionnaire/QuestionnaireForm';
import { Paper } from '@material-ui/core';
import { MenuItem } from '@material-ui/core';
import { TextField } from '@material-ui/core';

interface Props {
  selectedEmployee: SelectedAppraisee & IObservableObject
}
function NoOptionsMessage(props: any) {
  return (
    <Typography
      color="textSecondary"
      style={{
        padding: `4px 8px`,
      }}
      {...props.innerProps}
    >
      {translation.t('employeeSingleSelect.noOptions')}
    </Typography>
  );
}

// @ts-ignore
function inputComponent({ inputRef, ...props }) {
  return <div   style={{
    display: 'flex',
    padding: 0,
  }} ref={inputRef} {...props} />;
}

function Control(props: any) {
  return (
    <TextField
      label={translation.t('employeeSingleSelect.label')}
      required={true}
      fullWidth={true}
      style={{marginTop: 8, marginBottom: 4}}
      InputLabelProps={{shrink: true,}}
      InputProps={{
        inputComponent,
        inputProps: {
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

function Menu(props:any) {
  return (
    <Paper square={true} style={{
      position: 'absolute',
      zIndex: 1,
      marginTop: 4,
      left: 0,
      right: 0,
    }} {...props.innerProps}>
      {props.children}
    </Paper>
  );
}

function Option(props: any) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

const component = {
  NoOptionsMessage,
  Control,
  Menu,
  Option
};

@observer
class EmployeeSingleSelect extends React.Component<Props> {
  public state = {
    single: null,
  };

  @observable private employees: EmployeeDto[] = [];

  constructor(props: Props) {
    super(props)
  }

  public componentDidMount(): void {
    if (this.props.selectedEmployee.appraisee) {
      const currentEmployee = this.props.selectedEmployee.appraisee;
      this.setState({
        'single': {
          value: currentEmployee.id,
          label: currentEmployee.firstName + ' ' + currentEmployee.lastName,
          selectedEmployee: currentEmployee,
        }
      })
    }
    this.loadEmployees();
  }

  public render() {
    const {single} = this.state;

    return (
        <Select
          value={single}
          onChange={this.handleChange('single')}
          options={this.toOption()}
          isSearchable={true}
          components={component}
          placeholder={translation.t('employeeSingleSelect.placeholder')}
        />
    );
  }

  private handleChange = (name: string) => (value: any) => {
    this.props.selectedEmployee.appraisee = value.selectedEmployee;
    this.setState({
      [name]: value,
    });
  };

  private loadEmployees = () => {
    getEmployees({searchText: ''}, {page: 0, size: 1000000,}).then(page => {
      this.employees = page.content;

    });
  };

  private toOption = () => {
    return this.employees.map(
      (employee: EmployeeDto) => ({
        value: employee.id,
        label: employee.firstName + ' ' + employee.lastName,
        selectedEmployee: employee,
      })
    )
  }

}

export default EmployeeSingleSelect;
